export default function FormGroup({ className, children }) {
   return <div className={className}>{children}</div>;
}

//form group is used to control mainly input and form  margins, containers etc
